<template>
  <v-container>
    <v-stepper v-model="e1">
      <v-card class="lime elevation-0 rounded-0" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">
            KNDI ATRI & ACREPHAP Grant Writing Training Attendance Register
          </h3>
        </v-card-title>
      </v-card>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          color="lime"
          v-if="step_one == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 1"
          :rules="[() => false]"
          step="1"
          v-else-if="step_one == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <!--<template v-for="upload in uploads">
            <v-stepper-step :complete="e1 > upload.step" :step="upload.step" editable></v-stepper-step>
  
            <v-divider v-if="upload.step !== uploads" :key="upload.step"></v-divider>
          </template>-->
      </v-stepper-header>
      <v-stepper-items>
        <v-snackbar v-model="snackbar" :multi-line="mode" :right="x" :top="y">
          {{ snackbar_text }}
          <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-stepper-content step="1">
          <form @submit.prevent="StepOne">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>Name</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.name"
                    :error-messages="errors.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Email</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.email"
                    :error-messages="errors.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>University</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.university"
                    :error-messages="errors.university"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Department</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.department"
                    :error-messages="errors.department"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Highest education level</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.education_level"
                    :error-messages="errors.education_level"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Area of Study</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.area_of_study"
                    :error-messages="errors.area_of_study"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Have you won any grants before?</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-radio-group
                    v-model="register.grant_history"
                    wrap
                    :error-messages="errors.grant_history"
                  >
                    <v-radio label="Yes" value="Yes" color="lime"></v-radio>
                    <v-radio label="No" value="No" color="lime"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <h4>Note down some of the grants</h4>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.grants_won"
                    :error-messages="errors.grants_won"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Profile photo</h4>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Upload Document"
                    v-model="file_name_c"
                    :error-messages="errors.select_file"
                    @click="onPickFileC"
                    color="lime"
                    prepend-icon="attach_file"
                    append-outer-icon="clear"
                    @click:append-outer="clearC"
                    readonly
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputC"
                    id="fileInputC"
                    @change="onFilePickedC"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepOne"
              v-if="disabled == false"
              >submit</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; submitting
            </v-btn>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Processing
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from "vue"
import { grant_writing_training_Url } from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      e1: 0,
      e6: 1,
      disabled: false,
      step_one: true,
      downloaded: false,
      register: {
        name: "",
        email: "",
        university: "",
        department: "",
        education_level: "",
        area_of_study: "",
        grant_history: "",
        grants_won: "",
        select_file: ""
      },
      errors: {
        name: "",
        email: "",
        university: "",
        department: "",
        education_level: "",
        area_of_study: "",
        grant_history: "",
        grants_won: "",
        select_file: ""
      },
      file_name_c: "",
      errors_training_interest: false,
      series: [
        /*{
            id: 1,
            name: "November 2nd-13th 2020 {Day Class Schedule}"
          },
          {
            id: 2,
            name: "November 2nd-27th 2020 {Evening Class Schedule} "
          },
          {
            id: 3,
            name: "April 2021 {Day Class Schedule} "
          },
          {
            id: 4,
            name: "April 2021 {Evening Class Schedule} "
          },*/
        {
          id: 5,
          name: "August 2021 {Evening Class Schedule} "
        }
      ],
      dialog: false
    }
  },
  beforeMount() {
    //this.downloaded = true
    //this.fetchData()
    this.dialog = false
  },
  /*beforeRouteLeave(to, from, next) {
      if (!window.setIntervalConfirm) {
        next()
      } else {
        clearInterval(setIntervalConfirm)
        next()
      }
    },
    mounted() {
      var counter = 0
      var vm = this
      window.setIntervalConfirm = setInterval(function() {
        counter += 1
  
        if (!vm.training_institutions.length) {
          vm.fetchData()
        }
  
        if (counter === 3) {
          clearInterval(setIntervalConfirm)
        }
      }, 60000)
    },*/
  methods: {
    StepOne() {
      var vm = this
      vm.disabled = true
      if (
        vm.register.name == "" ||
        vm.register.email == "" ||
        vm.register.grant_history == "" ||
        vm.register.university == "" ||
        vm.register.department == "" ||
        vm.register.education_level == "" ||
        vm.register.area_of_study == "" ||
        vm.register.select_file == ""
      ) {
        if (vm.register.name == "") {
          vm.errors.name = "Please answer the above question"
        } else {
          vm.errors.name = ""
        }
        if (vm.register.email == "") {
          vm.errors.email = "Please answer the above question"
        } else {
          vm.errors.email = ""
        }
        if (vm.register.grant_history == "") {
          vm.errors.grant_history = "Please answer the above question"
        } else {
          vm.errors.grant_history = ""
        }
        if (vm.register.university == "") {
          vm.errors.university = "Please answer the above question"
        } else {
          vm.errors.university = ""
        }
        if (vm.register.department == "") {
          vm.errors.department = "Please answer the above question"
        } else {
          vm.errors.department = ""
        }
        if (vm.register.education_level == "") {
          vm.errors.education_level = "Please answer the above question"
        } else {
          vm.errors.education_level = ""
        }
        if (vm.register.area_of_study == "") {
          vm.errors.area_of_study = "Please answer the above question"
        } else {
          vm.errors.area_of_study = ""
        }
        if (vm.register.select_file == "") {
          vm.errors.select_file = "Please upload a profile photo"
        } else {
          vm.errors.select_file = ""
        }
        vm.step_one = false
        vm.disabled = false
      } else {
        vm.errors.name = ""
        vm.errors.email = ""
        vm.errors.grant_history = ""
        vm.errors.university = ""
        vm.errors.department = ""
        vm.errors.education_level = ""
        vm.errors.area_of_study = ""
        vm.errors.grants_won = ""
        vm.errors.select_file = ""
        vm.step_one = true
        //vm.disabled = false
        vm.submit()
      }
    },
    onPickFileC() {
      var vm = this
      vm.$refs.fileInputC.click()
    },
    onFilePickedC(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.register.select_file = e.target.result
        vm.file_name_c = file.name
        //console.log(vm.file_name_c)
      }
    },
    clearC() {
      var vm = this
      vm.$refs.fileInputC.value = ""
      vm.file_name_c = ""
      vm.register.select_file = ""
    },
    submit() {
      var vm = this
      vm.downloaded = true
      const data = {
        name: vm.register.name,
        email: vm.register.email,
        grant_history: vm.register.grant_history,
        university: vm.register.university,
        department: vm.register.department,
        education_level: vm.register.education_level,
        area_of_study: vm.register.area_of_study,
        grants_won: vm.register.grants_won,
        select_file: vm.register.select_file
      }

      axios
        .post(grant_writing_training_Url, data)
        .then(function(response) {
          if (response.data.stored) {
            vm.e1 = 1
            vm.dialog = true
            swal({
              title: "Submitted",
              text: "Your application was submitted successfully",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "register" })
            vm.disabled = false
            vm.register.name = ""
            vm.register.email = ""
            vm.register.grant_history = ""
            vm.register.university = ""
            vm.register.department = ""
            vm.register.education_level = ""
            vm.register.area_of_study = ""
            vm.register.grants_won = ""
            vm.register.select_file = ""
            vm.file_name_c = ""
          } else if (response.data.file_error_select_file) {
            swal({
              title: "File Error",
              text: "Only jpeg or png format required for Profile photo",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.errors.file_s = "Please upload a file in jpeg or png format only"
            vm.disabled = false
          } else {
            swal({
              title: "Failed",
              text: "Please contact KNDI through atri@kndi.institute",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            vm.downloaded = false
          }
        })
        .catch(function(error) {
          console.log(error)
          Vue.set(vm.$data, "errors", error.response.data)
          vm.disabled = false
          vm.downloaded = false
          vm.step_one = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/grant-writing-training-application.vue